import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Typography
} from '@material-ui/core';

import { Skeleton } from '@material-ui/lab';

class Title extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        skeleton: PropTypes.bool
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, title, skeleton, children } =this.props;

        if (skeleton) { return <Skeleton animation="wave" height={16} width={139} variant="rect" />; }

        return (
            <div className={classes.titleContainer}>
                <Typography className={classes.title}>{title}</Typography>
                {children}
            </div>
        );
    }
}

const style = theme => ({
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '16px',
        '&:not(:first-child)': {
            marginTop: theme.constants.verticalMargin * 2
        }
    },
    title: {
        ...theme.typography.h6,
        lineHeight: 'initial',
        color: theme.palette.grey.variant5
    }
});

export default withStyles(style)(Title);